exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".title[data-v-72462d25] {\n  display: inline-block;\n}\n[data-v-72462d25] .custom-tab-list .nav-tabs {\n  width: calc(100% - 5px);\n  -ms-flex-wrap: wrap;\n      flex-wrap: wrap;\n}\n[data-v-72462d25] .custom-tab-list .nav-tabs li {\n    border-bottom: 0px;\n}\n", ""]);

// exports
